import { makeStyles } from '@material-ui/styles'
import { Divider, Stack, styled, Typography, useTheme } from '@mui/material'
import { grey } from '@mui/material/colors'
import { Box } from '@mui/system'
import { useEffect, useState } from 'react'
import { BsFileEarmarkArrowDown } from 'react-icons/bs'
import spreadsheet from '../../../../../utils/spreadsheet'
import Modal from '../../../../molecules/Modal'
import { Button as CustomButton, Input } from '../../../../styled'
import Header from './Header'
import { getHeaders, getList } from './logList'
import PageSkeleton from './Skeleton'
import DataTable from './Table'

const CustomDivider = styled(Divider)(()=>({
    marginBottom: "2%",
    marginTop: "2%",
    display: "box"
}))

export default function Main() {

    const [loading, setLoading] = useState(true)
    const [modalOpen, setModalOpen] = useState(false)

    useEffect(()=>{

        setTimeout(()=>{
            setLoading(false)
        }, 1000)

    },[])

    const handleOnHeaderButtonClick =()=>{
        setModalOpen(modalOpen ? false : true)
    }

    const handleOnExport = ()=>{

        let salesHistory = getList()
        let objKeys:(string|number)[][] = []

        salesHistory.forEach((history)=>{
            const arr = Object.values(history)
            objKeys.push(arr)
        })

        const aoa = [
            getHeaders(),
            ...objKeys
        ]

        spreadsheet.aoaToSpreadSheet(aoa, "User logs")
        setModalOpen(false)
        
        
    }

    return (
        <Stack
            direction="column"
            spacing={2}
        >
            <Header handleOnHeaderButtonClick={handleOnHeaderButtonClick} />

            <CustomDivider />

            {
                loading ? <PageSkeleton /> : <Content />
            }

            <Modal
                title="Export user logs"
                subtitle="Select time range to export data"
                visible={modalOpen}
                setVisibility={setModalOpen}
            >
                <Box
                >
                    <Stack 
                        direction="row"
                        sx={{width: "100%", marginBottom: "1rem"}}
                        spacing={2}
                    >
                        <Stack sx={{width: "100%"}}>
                            <Typography variant="subtitle2" color="grey.500">Start Date:</Typography>
                            <Input type="date" />
                        </Stack>
                        <Stack sx={{width: "100%"}}>
                            <Typography variant="subtitle2" color="grey.500">End Date:</Typography>
                            <Input type="date" />
                        </Stack>
                    </Stack>

                    <Box
                        sx={{marginTop: "1.5rem", display: "flex", justifyContent: "flex-end"}}
                    >
                        <CustomButton 
                            startIcon={<BsFileEarmarkArrowDown />} 
                            variant="contained" 
                            color="secondary" 
                            disableElevation={true}
                            onClick={handleOnExport}
                        >
                            <Typography  color="primary" sx={{fontSize:"13px"}} >Download</Typography>
                        </CustomButton>
                    </Box>

                </Box>
            </Modal>

        </Stack>
    )

}

function Content(){

    const theme = useTheme()

    const useStyles = makeStyles({
        content:{
            flex: 1, 
            border: `.5px solid rgba(255, 255, 255, 0.1)`,
            borderRadius: "4px", 
            minHeight: "420px", 
            backgroundColor: theme.palette.primary.main,
            padding: "1rem"
        },
        searchField:{
            backgroundColor: theme.palette.primary.dark,
            border: `.5px solid rgba(255, 255, 255, 0.1)`,
            padding: ".3rem",
            borderRadius: "3px",
            color: grey[200],
            fontWeight: "normal",
            fontSize: "14px",
            outline: "none"
        }
    })

    const classes = useStyles()

    return(
        <Stack
            direction="column"
            spacing={2}
        >

            <Box className={classes.content} >

                <Stack
                    sx={{height: "100%"}}
                    direction="column"
                    spacing={2}
                >

                    <DataTable 
                        title="User logs"
                        tableBodyData={getList()}
                        tableHeadData={getHeaders()}
                        handleItemClick={()=>{}}
                    />

                </Stack>

                
            </Box>

        </Stack>
    )

}